<template>
  <v-row justify="space-around">
      <v-dialog
        transition="dialog-top-transition"
        v-model="dialogalert"
      >
        <template >
        <v-alert
        type="success"
        >Contraseña Restablecida Correctamente</v-alert>
        </template>
      </v-dialog>
  </v-row>
</template>

<script >
export default {
  name: 'dialogAlertRestablecer',
  props: ['dialogalert'],
  comments: {

  },
  mixins: [],
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
  }
}
</script>
